<template>

<div align="justify">
    <div class="h5" align="center">Ошибка 404</div>
    <div align="center">Запрашиваемая страница не найдена</div>
    <div align="center">
        <img src="/img/404.gif" alt="Responsive image" class="img-fluid mx-auto d-block">
    </div>
</div>

</template>

<script>
export default {
    name: 'PagePhoto'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

